import { createRoute, lazyRouteComponent, notFound } from "@tanstack/react-router";
import { rootRoute } from '../../../App';
import { getPublishedRecordQuery, getPublishedReviewByIdQuery } from '../../../api/publishedReviewsApi';
import { FullPageLoader } from '../../../components/FullPageLoader';

export const publishedRecordRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/published/$reviewId/records/$recordId",
    loader: async ({ context, params }) => {
        const [review, record] = await Promise.all([
            context.queryClient.ensureQueryData(getPublishedReviewByIdQuery(params.reviewId)),
            context.queryClient.ensureQueryData(getPublishedRecordQuery(params.reviewId, params.recordId)),
        ]);
        if (!review || !record) throw notFound();
    },
    component: lazyRouteComponent(() => import('./PublishedRecord.page')),
    pendingComponent: () => <FullPageLoader />,
});
